export const STUDENT_STATUSES = {
  STUDYING: 'Studying',
  TEMPORARILY_NOT_STUDYING: 'TemporarilyNotStudying',
  REMOVED_FROM_LIST: 'RemovedFromList',
  GRADUATED: 'Graduated'
};